/* eslint-disable react/no-danger */
import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import {
  arrayOf, params, shape, string as stringType, useDataModel
} from '@thd-nucleus/data-sources';
import {
  Heading, Image, Col, Row
} from '@thd-olt-component-react/core-ui';
import { Tile } from '@thd-olt-component-react/tile';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { Faq } from '../Faq/Faq';
import styles from './home-services-seo.module.scss';
import { StoreDetailsContext } from '../StoreDetails.context';

const cx = classNames.bind(styles);

const HomeServicesSEO = () => {

  const { storeId } = useContext(StoreDetailsContext);
  const options = {
    variables: {
      storeId,
    }
  };
  const { data, loading, error } = useDataModel('seoHomeServices', options);
  const seoContent = data?.seoHomeServices[0];
  const seoGuides = data?.seoHomeServices[1];
  const content = seoContent?.content || {};
  const guides = seoGuides?.content || {};
  const faq = seoContent?.faq || [];

  if (loading) {
    return (
      <Tile shadow={false}>
        <LoadingPlaceholder
          color="#E0E0E0"
          rows={10}
          ready={false}
          style={{ height: '500px' }}
        >
          Loading...
        </LoadingPlaceholder>
      </Tile>
    );
  }
  if (!seoContent || error) return null;

  return (
    <div className={cx('service-content')}>
      <Tile className={cx('service-content__container')}>
        <Heading title={seoContent.header} underline />
        {content && content.map(({ imageUrl, text, category }, index) => {
          return (
            <Row key={index}>
              <Col xs={3}>
                <Image
                  lazy
                  className={cx('service-content__image')}
                  src={imageUrl}
                  alt={category || ''}
                />
              </Col>
              <Col xs={9} className={cx('service-content__item')}>
                { category && (
                  <h3 className={cx('service-content__item--category')}>
                    {category}
                  </h3>
                )}
                <div className={cx('service-content__item--text')} dangerouslySetInnerHTML={{ __html: text }} />
              </Col>
            </Row>
          );
        })}
        <Faq faq={faq} />
        {
          seoGuides
        && (
          <Row>
            <Col xs={9} className={cx('service-content__item')}>
              <h3 className={cx('service-content__item--category')}>
                {seoGuides.header}
              </h3>
              {
                guides.map((guide, index) => {
                  return (
                    <div key={index}>
                      <div
                        className={cx('service-content__item--text')}
                        dangerouslySetInnerHTML={{ __html: guide.text }}
                      />
                      <br />
                    </div>
                  );
                })
              }
            </Col>
          </Row>
        )
        }
      </Tile>
    </div>
  );
};

HomeServicesSEO.displayName = 'HomeServicesSEO';

HomeServicesSEO.dataModel = {
  seoHomeServices: params({ storeId: stringType().isRequired() }).arrayOf(shape({
    header: stringType(),
    subHeader: stringType(),
    content: arrayOf(shape({
      imageUrl: stringType(),
      text: stringType(),
      category: stringType()
    })),
    faq: arrayOf(shape({
      question: stringType(),
      answer: stringType()
    }))
  }))
};

export { HomeServicesSEO };